/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TenantLicenseDeviceDto
 */
export interface TenantLicenseDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    masterDeviceId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    expirationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantLicenseDeviceDto
     */
    readonly daysLeft?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantLicenseDeviceDto
     */
    readonly isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantLicenseDeviceDto
     */
    $type?: TenantLicenseDeviceDtoTypeEnum;
}


/**
 * @export
 */
export const TenantLicenseDeviceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLicenseComponentDtoTenantLicenseDeviceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.LicenseComponent.Dto.TenantLicenseDeviceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantLicenseDeviceDtoTypeEnum = typeof TenantLicenseDeviceDtoTypeEnum[keyof typeof TenantLicenseDeviceDtoTypeEnum];


/**
 * Check if a given object implements the TenantLicenseDeviceDto interface.
 */
export function instanceOfTenantLicenseDeviceDto(value?: unknown): value is TenantLicenseDeviceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantLicenseDeviceDtoTypeEnum)[0];
}

export function TenantLicenseDeviceDtoFromJSON(json: any): TenantLicenseDeviceDto {
    return TenantLicenseDeviceDtoFromJSONTyped(json, false);
}

export function TenantLicenseDeviceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantLicenseDeviceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'masterDeviceId': json['masterDeviceId'],
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'serialNumber': json['serialNumber'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deliveryDate': !exists(json, 'deliveryDate') ? undefined : json['deliveryDate'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : json['expirationDate'],
        'daysLeft': !exists(json, 'daysLeft') ? undefined : json['daysLeft'],
        'isValid': !exists(json, 'isValid') ? undefined : json['isValid'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TenantLicenseDeviceDtoToJSON(value?: TenantLicenseDeviceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'masterDeviceId': value.masterDeviceId,
        'model': value.model,
        'subModel': value.subModel,
        'serialNumber': value.serialNumber,
        'id': value.id,
        'iuid': value.iuid,
        'name': value.name,
        'deliveryDate': value.deliveryDate,
        'expirationDate': value.expirationDate,
        '$type': value.$type,
    });
}

